<template>
    <app-page title="Fazer pedido" subtitle="Por favor escolha os produtos" :check-user-permission="false">

        <!-- Ações -->
        <router-link
            :to="{name: 'cart'}" class="button is-primary is-rounded is-hidden-touch"
            slot="actions"
            :disabled="totalCartPrice <= 0"
        >
            Enviar Pedido
        </router-link>

        <!-- Aviso -->
        <b-message title="Aviso" type="is-warning" v-if="notice">{{ notice }}</b-message>

        <!-- Produtos -->
        <storeProductList/>

        <!--  Rodapé -->
        <div class="card" slot="footer" v-if="totalCartPrice">
            <div class="card-content">
                <div class="columns is-mobile is-middle">
                    <div class="column">
                        <div class="is-small">Total (R$)</div>
                        <div class="is-size-3">{{ totalCartPrice | money('') }}</div>
                    </div>
                    <div class="column is-narrow">
                        <router-link :to="{name: 'cart'}" class="button is-primary is-rounded" slot="actions">Enviar
                            Pedido
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </app-page>
</template>

<script>
import AppPage from "../components/AppPage";
import storeProductList from "@/modules/cart/storeProductList";
import {mapGetters} from "vuex";
import {get as getConf} from '../modules/conf/conf.actions'

export default {
    name: "HomePage",
    components: {AppPage, storeProductList},

    computed: {
        ...mapGetters(['totalCartPrice'])
    },

    data() {
        return {
            notice: null
        }
    },

    async created() {
        const loading = this.$buefy.loading.open();
        this.notice = await getConf('notice');

        loading.close();

    }
}
</script>
